import Enumerable from "linq";
import { IContentSource } from "../../domain/drawing/IContentSource";
import { IClipboardItem } from "../../domain/system";
import { LoggerFactory } from "../../utilities/logger";
import { ClipboardItem } from "./ClipboardItem";

export class ClipboardRepository {
  private readonly _logger = LoggerFactory.getLogger();
  private static _texts: IClipboardItem<string>[] = [];
  private static readonly _maxCount: number = 10;
  private static _lastText: string = undefined; // 初期化未の場合undefined.

  public static registerText(text: string): void {
    // 初回より前からclipboradに入ってた値のガード.
    if (text === undefined) {
      return; // 初期化未と同じ値は処理しない.(念のため.)
    }
    if (ClipboardRepository._lastText === undefined) {
      // 初期化未だった場合は初期化だけ行う.
      ClipboardRepository._lastText = text;
      return;
    }
    if (!text || ClipboardRepository._lastText === text) {
      return; // 空文字列、前回値と同じ値は登録しない.
    }
    if (ClipboardRepository._texts.some(t => t.value === text)) {
      return; // 同じ値は登録しない.
    }
    ClipboardRepository._lastText = text;

    const nextSequenceNo = this.generateNextSequenceNo(ClipboardRepository._texts.map(t => t.sequenceNo));
    const newItem = new ClipboardItem<string>(nextSequenceNo, text);
    Object.freeze(newItem);
    ClipboardRepository._texts.push(newItem);

    if (ClipboardRepository._texts.length > ClipboardRepository._maxCount) {
      // 最大数を超えていたら、先頭のひとつを取り除く
      ClipboardRepository._texts.splice(0, 1);
    }
  }

  static generateNextSequenceNo(values: number[]): number {
    const maxValue = (values.length !== 0)
      ? Enumerable.from(values).max()
      : 0;
    return Math.max(maxValue, values.length) + 1;
  }

  async getLatestTexts(count: number, latestSequenceNo?: number): Promise<IClipboardItem<string>[]> {
    const items = !latestSequenceNo
      ? ClipboardRepository._texts
      : ClipboardRepository._texts.filter(i => i.sequenceNo > latestSequenceNo);
    return items.slice(0, count);
  }

  clearTexts(): void {
    ClipboardRepository._texts = [];
    ClipboardRepository._lastText = undefined;
  }

  removeTexts(sequenceNo: number): void {
    const index = ClipboardRepository._texts.findIndex(t => t.sequenceNo === sequenceNo);
    if (index > -1) {
      ClipboardRepository._texts.splice(index, 1);
    }
  }

  async getLatestImages(count: number, latestSequenceNo?: number): Promise<IClipboardItem<IContentSource>[]> {
    this._logger.debug("TODO: implement");
    return [];
  }
}
